/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicAmazonProductVariants.internal

import features.getPublicAmazonProductVariants.models.PublicRewardResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.getPublicAmazonProductVariants.internal.GetPublicAmazonProductVariantsUseCase.Params

internal class GetPublicAmazonProductVariantsUseCase : AsyncUseCase<PublicRewardResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val rewardSlug: String,
        val externalProductId: String
    )

    private val getPublicAmazonProductVariantsService: GetPublicAmazonProductVariantsService = GetPublicAmazonProductVariantsServiceImpl()

    override suspend fun run(params: Params): Result<PublicRewardResponseModel> {
        return getPublicAmazonProductVariantsService.getPublicAmazonProductVariants(
            overrideHeaders = params.overrideHeaders,
            rewardSlug = params.rewardSlug,
            externalProductId = params.externalProductId
        )
    }
}
